export default __webpack_public_path__ + "static/Forms_Hover-99a96b3aefc37e9ba50e4288c5aa9d1e.png";